// Storage for client profiles: photos and session notes
// Keyed by clientId (waiver.id)

const PROFILES_KEY = 'hbc_profiles_v1';
const NOTES_KEY = 'hbc_session_notes_v1';

function safeLoad(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

// ---------- Photos ----------

function loadAllProfiles() {
  return safeLoad(PROFILES_KEY, {}) || {};
}

function saveAllProfiles(map) {
  localStorage.setItem(PROFILES_KEY, JSON.stringify(map));
}

export function getProfilePhotos(clientId) {
  const all = loadAllProfiles();
  return all[clientId]?.photos || [];
}

export function addProfilePhoto(clientId, photo) {
  const all = loadAllProfiles();
  const p = all[clientId] || { photos: [] };
  p.photos = [photo, ...(p.photos || [])];
  all[clientId] = p;
  saveAllProfiles(all);
  return p.photos;
}

export function deleteProfilePhoto(clientId, photoId) {
  const all = loadAllProfiles();
  const p = all[clientId];
  if (!p) return [];
  p.photos = (p.photos || []).filter((x) => x.id !== photoId);
  all[clientId] = p;
  saveAllProfiles(all);
  return p.photos;
}

// ---------- Session Notes ----------

export function loadAllNotes() {
  const raw = safeLoad(NOTES_KEY, []);
  return Array.isArray(raw) ? raw : [];
}

export function getNotesForClient(clientId) {
  if (!clientId) return [];
  return loadAllNotes()
    .filter((n) => n.clientId === clientId)
    .sort((a, b) => (a.date < b.date ? 1 : -1));
}

export function addSessionNote(note) {
  const list = loadAllNotes();
  list.unshift(note);
  localStorage.setItem(NOTES_KEY, JSON.stringify(list));
  return list;
}

export function deleteSessionNote(id) {
  const list = loadAllNotes().filter((n) => n.id !== id);
  localStorage.setItem(NOTES_KEY, JSON.stringify(list));
  return list;
}

export function generateId(prefix = 'x') {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}

// ---------- Phone lookup ----------

// Normalize a phone number to digits only for matching
export function normalizePhone(s) {
  return String(s || '').replace(/\D/g, '');
}

export function findClientByPhone(waivers, phone) {
  const norm = normalizePhone(phone);
  if (!norm || norm.length < 7) return null;
  // Prefer exact digit match, else last-7-digits match
  return (
    waivers.find((w) => normalizePhone(w.phone) === norm) ||
    waivers.find((w) => {
      const d = normalizePhone(w.phone);
      return d && (d.endsWith(norm) || norm.endsWith(d));
    }) ||
    null
  );
}
